/**
 * CUSTOMER_GUIDELINES - can add/update/delete Customer Guidelines
 * MESSAGES - can send broadcast messages
 */
export enum ManagerRoles {
  CUSTOMER_GUIDELINES = 'LTL_INSPECTOR_CUSTOMER_GUIDELINES',
  MESSAGES = 'LTL_INSPECTOR_MESSAGES'
}
